import styled from 'styled-components';
import { allStyles } from '../styleHelper2';
import styleFilter from '../styleFilter';

const Icon = styled(styleFilter(styled.i``))`
  display: inline-block;
  ${allStyles()}
`;

export default Icon;
